(function() {
  angular
    .module('webAgro1App')
    .directive('fixedDecimalInput', fixedDecimalInput);

  // eslint-disable-next-line max-lines-per-function
  function fixedDecimalInput(DecimalsService) {
    return {
      require: 'ngModel',
      // eslint-disable-next-line max-params, max-lines-per-function
      link: function(scope, element, attrs, ngModelCtrl) {
        const modeAttr = attrs.fixedDecimalInput;
        if (modeAttr && modeAttr !== 'milhar') {
          // eslint-disable-next-line no-console
          console.error(`fixed-decimal-input: valor "${modeAttr}" não reconhecido, use "milhar" ou omita o atributo.`);
        }
        const allowThousands = modeAttr === 'milhar';
        const originalTitle = attrs.title || '';

        function formatViewValue(value) {
          if (value === null || typeof value === 'undefined' || value === '') {
            return DecimalsService.formatForInput(0);
          }

          const truncated = DecimalsService.isDecimalV2Enabled() ?
            DecimalsService.formatDoseOrQuantityForDisplay(value) :
            +String(value).replace(/(\.\d{4})\d+$/, '$1');

          return DecimalsService.formatForInput(truncated);
        }

        function applyValue(newValue) {
          const valueFormatted = formatViewValue(newValue);
          if (DecimalsService.isDecimalV2Enabled()) {
            ngModelCtrl.$setViewValue(valueFormatted);
            ngModelCtrl.$render();
          } else {
            element.val(valueFormatted);
          }
        }

        function setInvalidFeedback(valid) {
          element.toggleClass('input-error', !valid);
          element.attr('title', valid ? originalTitle : 'Valor inválido');
        }

        function parseValue(viewValue) {
          if (viewValue === null || viewValue === '') {
            ngModelCtrl.$setValidity('decimal', true);
            setInvalidFeedback(true);
            return viewValue;
          }

          const parsed = allowThousands ?
            DecimalsService.toNumberWithThousands(viewValue) :
            DecimalsService.toNumber(viewValue);
          const valid = !isNaN(parsed) && parsed >= 0;

          ngModelCtrl.$setValidity('decimal', valid);
          setInvalidFeedback(valid);
          if (!valid) {
            return void 0;
          }
          return parsed;
        }

        scope.$watch(attrs.ngModel, function(newValue) {
          if (newValue !== null && element[0] !== document.activeElement) {
            applyValue(newValue);
          }
        });

        ngModelCtrl.$parsers.push(parseValue);
        ngModelCtrl.$formatters.push(formatViewValue);

        element.on('blur', function() {
          scope.$applyAsync(function() {
            if (ngModelCtrl.$error.decimal) {
              return;
            }
            const value = ngModelCtrl.$modelValue;
            applyValue(value);
          });
        });
      }
    };
  }

  fixedDecimalInput.$inject = ['DecimalsService'];
}());
